import { matchAllconditionsInQuestions } from "../../../utils/conditionalRules";
import { getDefaultQuestionValue } from "./mapQuestions";

/**
 * Checks if a question is mandatory based on its properties and conditions.
 * @param {Object} question
 * @param {Array} questions
 * @returns {boolean}
 */
export function isQuestionMandatory(question, questions) {
    const mandatoryDependencyCheck = question?.props?.mandatoryWhen ? matchAllconditionsInQuestions(question?.props?.mandatoryWhen, questions) : null;
    return Boolean(question.mandatory || mandatoryDependencyCheck?.ok);
}

/**
 * Checks if all mandatory questions are answered for a given followUp's mappedQuestions array.
 * @param {Array} questions
 * @returns {boolean}
 */
export function hasAllMandatoryQuestionsAnswered(questions) {
    if (!questions) return true;
    for (const question of questions) {
        const isMandatory = isQuestionMandatory(question, questions);

        if (isMandatory && !question.isAnswered) {
            return false;
        }
        if (question.questionType === "checkbox" && question.mandatory) {
            if (!question.value || question.value.length === 0) {
                return false;
            }
        }
        if ((question.questionType === "dropdown" || question.questionType === "text" || question.questionType === "decimal") && question.mandatory) {
            if (!question.value) {
                return false;
            }
        }
    }
    return true;
}

/**
 * Checks if all followUps in the questions object have all mandatory questions answered.
 * @param {Object} questionsObj
 * @returns {boolean}
 */
export function areAllFollowUpsMandatoryQuestionsAnswered(questionsObj) {
    const uuids = Object.keys(questionsObj || {});
    return uuids.every((uuid) => hasAllMandatoryQuestionsAnswered(questionsObj[uuid]?.mappedQuestions));
}

/**
 * Processes question visibility and mandatory status based on conditions.
 * @param {Object} question
 * @param {Array} questions
 * @returns {Object} { dependencyCheck, isVisible, mandatoryCheck, isMandatory }
 */
export function processQuestionVisibilityAndMandatory(question, questions) {
    const metadata = {
        dependsOn: question?.props?.dependsOn,
        mandatoryWhen: question?.props?.mandatoryWhen,
        clearWhenHidden: question?.props?.clearWhenHidden,
    };

    const dependencyCheck = matchAllconditionsInQuestions(metadata.dependsOn, questions);
    const isVisible = dependencyCheck.ok;

    // If the question becomes hidden and metadata specifies to clear it,
    // reset the question value and answered/formatted metadata to defaults.
    if (!isVisible && metadata.clearWhenHidden) {
        const defaultValue = getDefaultQuestionValue(question?.questionType);
            question.value = defaultValue;
            question.isAnswered = false;
        question.formattedValue = Array.isArray(defaultValue)
            ? { name_en: "", name_fr: "" }
            : { name_en: defaultValue ?? "", name_fr: defaultValue ?? "" };
    }

    const mandatoryCheck = metadata.mandatoryWhen ? matchAllconditionsInQuestions(metadata.mandatoryWhen, questions) : null;
    const isMandatory = isVisible && isQuestionMandatory(question, questions);

    return { dependencyCheck, isVisible, mandatoryCheck, isMandatory };
}
